import styled from 'styled-components'

export const ConnectedWalletsContainer = styled.div`
  .button-content {
    white-space: nowrap;
  }
`
